import { render } from "./AppBanner.vue?vue&type=template&id=15c37620&scoped=true"
import script from "./AppBanner.vue?vue&type=script&lang=js"
export * from "./AppBanner.vue?vue&type=script&lang=js"

import "./AppBanner.vue?vue&type=style&index=0&id=15c37620&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c37620"]])

export default __exports__